import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

export const toGetLoyaltyProgramDetails = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("program/toGetLoyaltyProgramDetails", async (lang) => {
  try {
    const response = await axios.get(
      `${baseUrlApi}portal/loyalty_program?lang=${lang}`
    );
    return response;
  } catch (error) {
    throw error;
  }
});
